import styled from "styled-components";

import theme from "config/theme";

import StyledImage from "components/Image";

export const Inner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 50px auto 0;

  @media (max-width: ${theme.size.tablet}) {
    margin: 40px auto 0;
  }

  @media (max-width: ${theme.size.mobile}) {
    flex-direction: column;
    margin: 30px auto 0;
  }
`;

export const Image = styled(StyledImage)`
  height: 90px;
  width: auto;
  margin: 0 40px;
  transition: ${theme.transition};

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 46em) {
    height: 70px;
    margin: 0 20px;
  }

  @media (max-width: ${theme.size.mobile}) {
    height: 70px;
    margin: 20px auto 10px;
  }
`;
